import DialogProviderComponent from "./DialogProvider";
export { default as Dialog } from "./Dialog";
export { default as DialogProvider, useDialog, dialog } from "./DialogProvider";

export { default as InfoIcon, getInfoDialogProps } from "./types/InfoDialog";
export {
  default as WarningIcon,
  getWarningDialogProps,
} from "./types/WarningDialog";
export {
  default as ConfirmIcon,
  getConfirmDialogProps,
} from "./types/ConfirmDialog";
export {
  default as SuccessIcon,
  getSuccessDialogProps,
} from "./types/SuccessDialog";
export { default as ErrorIcon, getErrorDialogProps } from "./types/ErrorDialog";

export default DialogProviderComponent;
